<template>
  <div class="navbar-root">
  <div class="navbar">
    <!-- 应用名称/Logo -->
    <div class="logo-container" @click="goToHome">
      <img class="app-logo" src="@/assets/image/logo.png" alt="logo" draggable="false">
    </div>

    <!-- 地区选择器 -->
    <div class="location-selector">
      <el-dropdown
        ref="locationDropdown"
        :visible.sync="locationDropdownVisible"
        trigger="click"
        @command="handleLocationChange"
      >
        <span class="location-text">
          {{ currentLocation }}
          <img class="el-icon-arrow-down" src="@/assets/image/xia1.png" alt="">
        </span>
        <el-dropdown-menu slot="dropdown" class="location-dropdown">
          <div class="popular-regions-header">
            <span class="header-label">热门地区</span>
            <div class="popular-regions">
              <span
                v-for="region in popularRegions"
                :key="region.value"
                class="popular-region-item"
                :class="{ active: currentLocation === region.label }"
                @click="handleLocationChange(region.value)"
              >
                {{ region.label }}
              </span>
            </div>
          </div>
          <div class="region-categories">
            <div
              v-for="category in regionCategories"
              :key="category.name"
              class="region-category"
            >
              <div class="category-name">{{ category.name }}</div>
              <div class="region-items">
                <span
                  v-for="region in category.regions"
                  :key="region.value"
                  class="region-item"
                  :class="{ active: currentLocation === region.label }"
                  @click="handleLocationChange(region.value)"
                >
                  {{ region.label }}
                </span>
              </div>
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 导航链接 -->
    <div class="nav-links">
      <router-link
        v-for="link in navLinks"
        :key="link.path"
        :to="link.path"
        class="nav-link"
        active-class="active"
      >
        {{ getNavLinkDisplayName(link) }}
      </router-link>
    </div>

    <!-- 未登录：入口按钮 + 弹窗；已登录：头像与身份下拉 -->
    <div class="right-menu">
      <template v-if="!isLoggedIn">
        <div class="auth-entry-buttons">
          <el-button type="primary" plain class="auth-btn" @click="memberAuthVisible = true">会员登录/注册</el-button>
          <el-button type="primary" class="auth-btn" @click="proAuthVisible = true">造价师/供应商登录注册</el-button>
        </div>
        <navbar-auth-dialog :visible.sync="memberAuthVisible" mode="member" @success="onNavbarAuthSuccess" />
        <navbar-auth-dialog :visible.sync="proAuthVisible" mode="professional" @success="onNavbarAuthSuccess" />
      </template>
      <el-dropdown
        v-else
        ref="userDropdown"
        :visible.sync="userDropdownVisible"
        class="avatar-container"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img
            :src="displayAvatar"
            class="user-avatar"
            alt=""
          >
          <div class="user-info-wrapper">
            <div class="user-name-line">
              <span class="username">{{ displayUsername }}</span>
              <span class="identity-chip">{{ identityRoleLabel }}</span>
              <presence-selector variant="navbar-inline" />
            </div>
            <span v-if="userInfo.is_member === 1" class="member-badge">
              <span class="member-days">剩余{{ userInfo.member_days_remaining || 0 }}天</span>
            </span>
          </div>
          <img class="el-icon-arrow-down" src="@/assets/image/xia2.png" alt="">
        </div>
        <el-dropdown-menu
          slot="dropdown"
          class="user-dropdown"
        >
          <!-- 用户信息区域 -->
          <div class="user-info-section">
            <div class="user-avatar-info">
              <img
                :src="displayAvatar"
                class="dropdown-avatar"
                alt=""
              >
              <div class="user-details">
                <div class="username">{{ displayUsername }}</div>
                <div class="user-status">
                  <span v-if="userInfo.group_id === 1 && userInfo.is_member === 1" class="status-badge member-status">
                    会员
                    <span class="member-days-text">(剩余{{ userInfo.member_days_remaining || 0 }}天)</span>
                  </span>
                  <span v-else class="status-badge role-badge">
                    {{ identityRoleLabel }}
                  </span>
                </div>
                <presence-selector variant="navbar-dropdown" />
              </div>
            </div>
            <el-button
              class="logout-btn"
              size="small"
              @click="logout"
            >退出</el-button>
          </div>

          <!-- 会员推广区域（仅会员用户显示） -->
          <div
            v-if="userInfo.group_id === 1"
            style="padding: 0 20px;position: relative; cursor: pointer;"
            @click="goToMembership"
          >
            <img
              class="membership-section"
              src="@/assets/image/vip1.png"
              alt="VIP图标"
            >
            <div v-if="userInfo.is_member === 1" class="vip-text">
              {{ userInfo.member_days_remaining || 0 }}天到期
            </div>
            <div v-else class="vip-text">开通</div>
          </div>

          <!-- 功能选项列表 -->
          <div class="profile-options">
            <div
              class="option-item"
              @click="goToRealNameAuth"
            >
              <img
                src="@/assets/image/smrz.png"
                alt="实名认证"
                class="option-icon"
              >
              <span class="option-text">实名认证</span>
              <img
                src="@/assets/image/you.png"
                alt="箭头"
                class="arrow-icon"
              >
            </div>
            <div
              class="option-item"
              @click="goToWallet"
            >
              <img
                src="@/assets/image/qianboa.png"
                alt="钱包"
                class="option-icon"
              >
              <span class="option-text">钱包</span>
              <img
                src="@/assets/image/you.png"
                alt="箭头"
                class="arrow-icon"
              >
            </div>
            <div
              class="option-item"
              @click="goToSettings"
            >
              <img
                src="@/assets/image/set.png"
                alt="设置"
                class="option-icon"
              >
              <span class="option-text">设置</span>
              <img
                src="@/assets/image/you.png"
                alt="箭头"
                class="arrow-icon"
              >
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTopNav } from '@/api/user'
import { isAuthenticated } from '@/utils/auth'
import { getNavbarRegionLabel, setRegionFromNavbar } from '@/utils/region'
import PresenceSelector from '@/components/PresenceSelector.vue'
import NavbarAuthDialog from '@/components/NavbarAuthDialog.vue'

export default {
  name: 'Navbar',
  components: { PresenceSelector, NavbarAuthDialog },
  data() {
    return {
      memberAuthVisible: false,
      proAuthVisible: false,
      currentLocation: '全国',
      popularRegions: [
        { label: '北京', value: 'beijing' },
        { label: '广东省', value: 'guangdong' },
        { label: '上海', value: 'shanghai' },
        { label: '河北省', value: 'hebei' },
        { label: '湖北省', value: 'hubei' }
      ],
      regionCategories: [
        {
          name: '不限',
          regions: [
            { label: '全国', value: 'nationwide' }
          ]
        },
        {
          name: '华北',
          regions: [
            { label: '北京', value: 'beijing' },
            { label: '天津', value: 'tianjin' },
            { label: '河北省', value: 'hebei' },
            { label: '山西省', value: 'shanxi' },
            { label: '内蒙古', value: 'inner_mongolia' }
          ]
        },
        {
          name: '东北',
          regions: [
            { label: '辽宁省', value: 'liaoning' },
            { label: '吉林省', value: 'jilin' },
            { label: '黑龙江省', value: 'heilongjiang' }
          ]
        },
        {
          name: '华东',
          regions: [
            { label: '上海', value: 'shanghai' },
            { label: '江苏省', value: 'jiangsu' },
            { label: '浙江省', value: 'zhejiang' },
            { label: '安徽省', value: 'anhui' },
            { label: '福建省', value: 'fujian' },
            { label: '江西省', value: 'jiangxi' },
            { label: '山东省', value: 'shandong' }
          ]
        },
        {
          name: '华中',
          regions: [
            { label: '湖北省', value: 'hubei' },
            { label: '湖南省', value: 'hunan' },
            { label: '河南省', value: 'henan' }
          ]
        },
        {
          name: '华南',
          regions: [
            { label: '广东省', value: 'guangdong' },
            { label: '广西', value: 'guangxi' },
            { label: '海南省', value: 'hainan' }
          ]
        },
        {
          name: '西南',
          regions: [
            { label: '重庆', value: 'chongqing' },
            { label: '四川省', value: 'sichuan' },
            { label: '贵州省', value: 'guizhou' },
            { label: '云南省', value: 'yunnan' },
            { label: '西藏', value: 'tibet' }
          ]
        },
        {
          name: '西北',
          regions: [
            { label: '陕西省', value: 'shaanxi' },
            { label: '甘肃省', value: 'gansu' },
            { label: '青海省', value: 'qinghai' },
            { label: '宁夏', value: 'ningxia' },
            { label: '新疆', value: 'xinjiang' }
          ]
        },
        {
          name: '其他',
          regions: [
            { label: '香港特别行政区', value: 'hong_kong' },
            { label: '澳门特别行政区', value: 'macao' },
            { label: '台湾省', value: 'taiwan' }
          ]
        },
        {
          name: '海外',
          regions: [
            { label: '亚洲', value: 'asia' },
            { label: '欧洲', value: 'europe' },
            { label: '美洲', value: 'americas' },
            { label: '非洲', value: 'africa' },
            { label: '澳洲', value: 'oceania' }
          ]
        }
      ],
      locationDropdownVisible: false,
      navLinks: [], // 初始化为空数组，通过API获取数据
      userDropdownVisible: false // 控制用户下拉菜单的显示/隐藏
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'username',
      'userInfo',
      'token'
    ]),
    // 处理头像显示，如果没有头像则使用默认头像
    displayAvatar() {
      const avatarUrl = this.avatar || this.userInfo.avatar
      if (avatarUrl) {
        // 如果头像URL已经在store中处理过，直接使用；否则使用全局方法处理
        return avatarUrl.startsWith('http') ? avatarUrl : this.$getImageUrl(avatarUrl)
      }
      return require('@/assets/image/logo.png')
    },
    // 处理用户名显示（已登录不含「游客」）
    displayUsername() {
      if (!this.token) {
        return ''
      }
      return this.username || this.userInfo.nickname || '用户'
    },
    identityRoleLabel() {
      const g = Number(this.userInfo.group_id)
      if (g === 2) return '造价师'
      if (g === 3) return '供应商'
      return '会员'
    },
    isCostEngineer() {
      return Number(this.userInfo.group_id) === 2
    },
    // 判断是否已登录
    isLoggedIn() {
      return !!this.token
    }
  },
  created() {
    this.currentLocation = getNavbarRegionLabel()
    // 只有登录状态才获取用户信息
    if (isAuthenticated()) {
      this.fetchUserProfile()
    }
    this.fetchNavLinks()
  },
  mounted() {
    this.updateNavbarHeight()
    window.addEventListener('resize', this.updateNavbarHeight)
    window.addEventListener('region-changed', this.syncLocationFromStore)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateNavbarHeight)
    window.removeEventListener('region-changed', this.syncLocationFromStore)
    document.documentElement.style.removeProperty('--navbar-total-height')
  },
  methods: {
    updateNavbarHeight() {
      this.$nextTick(() => {
        const h = this.$el ? this.$el.offsetHeight : 80
        document.documentElement.style.setProperty('--navbar-total-height', `${h}px`)
      })
    },
    syncLocationFromStore() {
      this.currentLocation = getNavbarRegionLabel()
    },
    isProfileNavLink(link) {
      const path = String(link?.path || '')
      return path === '/profile' || path.startsWith('/profile/')
    },
    getNavLinkDisplayName(link) {
      if (this.isProfileNavLink(link) && this.isCostEngineer) {
        return '工作平台'
      }
      return link.name
    },
    onNavbarAuthSuccess() {
      this.memberAuthVisible = false
      this.proAuthVisible = false
      this.fetchUserProfile()
    },
    // 跳转到首页
    goToHome() {
      this.$router.push('/')
    },
    // 获取用户信息
    async fetchUserProfile() {
      try {
        await this.$store.dispatch('user/getInfo')
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 可以选择显示默认信息或者跳转到登录页
      }
    },
    // 获取顶部导航数据
    async fetchNavLinks() {
      try {
        const response = await getTopNav()
        if (response && response.data) {
          // 将API返回的数据映射为组件需要的格式
          this.navLinks = response.data.map(item => {
            // 根据title映射到对应的路径
            const pathMap = {
              '材价信息': '/material',
              '造价案例': '/costcases',
              '造价师服务': '/service',
              '造价问答': '/costqa',
              '个人中心': '/profile'
            }
            return {
              id: item.id,
              name: item.title,
              path: pathMap[item.title] || '/'
            }
          })
        }
      } catch (error) {
        console.error('获取导航数据失败:', error)
        // 如果API调用失败，使用默认的导航数据
        this.navLinks = [
          { id: 1, name: '材价信息', path: '/material' },
          { id: 2, name: '造价案例', path: '/costcases' },
          { id: 3, name: '造价师服务', path: '/service' },
          { id: 4, name: '造价问答', path: '/costqa' },
          { id: 5, name: '个人中心', path: '/profile' }
        ]
      }
    },
    handleLocationChange(location) {
      // 从热门地区中查找
      let foundRegion = this.popularRegions.find(opt => opt.value === location)

      // 如果热门地区中没找到，从分类地区中查找
      if (!foundRegion) {
        for (const category of this.regionCategories) {
          foundRegion = category.regions.find(opt => opt.value === location)
          if (foundRegion) break
        }
      }

      const label = foundRegion?.label || '全国'
      setRegionFromNavbar(label)
      this.syncLocationFromStore()
      this.locationDropdownVisible = false
      this.$nextTick(() => {
        if (this.$refs.locationDropdown && typeof this.$refs.locationDropdown.hide === 'function') {
          this.$refs.locationDropdown.hide()
        }
      })
      this.$message.success(`已切换到${this.currentLocation}`)
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      // 退出后不进入项目登录页，直接跳转到指定站点
      window.location.replace('https://fww.jpjjjq.com/web/#/news_home')
    },
    goToMembership() {
      this.userDropdownVisible = false
      this.$router.push({
        path: '/profile/index',
        query: { activeMenu: '5' }
      })
    },
    goToRealNameAuth() {
      this.userDropdownVisible = false
      this.$router.push('/profile/shiming')
    },
    goToWallet() {
      this.userDropdownVisible = false
      this.$router.push({
        path: '/profile/index',
        query: { activeMenu: '3' }
      })
    },
    goToSettings() {
      this.userDropdownVisible = false
      this.$router.push({
        path: '/profile/index',
        query: { activeMenu: '11' }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-root {
  position: relative;
  z-index: 1001;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.navbar {
  height: 80px;
  overflow: visible;
  position: relative;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 20px;
  box-sizing: border-box;

  .logo-container {
    margin-right: 30px;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.8;
    }

    .app-logo {
      width: 160px;
      user-select: none;
      -webkit-user-drag: none;
      -moz-user-select: none;
      -ms-user-select: none;
      pointer-events: auto;
    }
  }

  // 地区选择器
  .location-selector {

    .location-text {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 20px;
      color: #333;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 6px;
      transition: background-color 0.3s ease;
      font-weight: bold;

      &:hover {
        background-color: #f5f5f5;
      }

      .el-icon-arrow-down {
        width: 18px;
      }
    }
  }

  .nav-links {
    flex: 1;
    min-width: 0;
    display: flex;
    gap: 50px;
    justify-content: space-around;

    .nav-link {
		height: 80px;
		line-height: 80px;
      text-decoration: none;
      color: #333;
      font-size: 18px;
      font-weight: 500;
      padding: 0px 16px;
      border-radius: 0;
      transition: all 0.3s ease;

      &:hover {
        color: #fff;
        background: linear-gradient(90deg, #0F6FE2, #0C89F2);
      }

      &.active {
		height: 80px;
		line-height: 80px;
        color: #fff;
        background: linear-gradient(90deg, #0F6FE2, #0C89F2);
        border-radius: 0;
      }
    }
  }

  .right-menu {
    flex-shrink: 0;

    .auth-entry-buttons {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: flex-end;

      .auth-btn {
        border-radius: 8px;
        font-weight: 600;
        padding: 10px 18px;
        font-size: 14px;
      }

      .el-button--primary.is-plain {
        color: #0f6fe2;
        border-color: #0f6fe2;
        background: #fff;

        &:hover {
          background: #ecf5ff;
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #ECF2FF;
        padding: 8px 16px;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: #e6f3ff;
          transform: translateY(-1px);
        }

        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
        }

        .guest-avatar {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f0f0f0;
          border-radius: 50%;

          .guest-icon {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }
        }

        .user-info-wrapper {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .user-name-line {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }

        .identity-chip {
          font-size: 12px;
          color: #0f6fe2;
          background: rgba(15, 111, 226, 0.12);
          padding: 2px 8px;
          border-radius: 10px;
          font-weight: 600;
          white-space: nowrap;
        }

        .username {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }

        .member-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: linear-gradient(135deg, #FFE082 0%, #FFCC02 100%);
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 11px;
          color: #E65100;
          font-weight: 600;
        }

        .member-icon {
          width: 14px;
          height: 14px;
        }

        .member-days {
          font-size: 11px;
          white-space: nowrap;
        }

        .el-icon-arrow-down {
          width: 18px;
        }
      }
    }
  }
}

// 地区下拉框样式
::v-deep .location-dropdown {
  min-width: 600px !important;
  max-width: 800px !important;
  padding: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

  .el-dropdown-menu__item {
    padding: 0 !important;
    line-height: normal !important;
  }
}

.popular-regions-header {
  background: #fff;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 20px;

  .header-label {
    font-size: 14px;
    color: #666;
    font-weight: 500;
    min-width: 60px;
  }

  .popular-regions {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;

    .popular-region-item {
      padding: 6px 12px;
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      color: #333;

      &:hover {
        background: #f0f8ff;
        border-color: #0f6fe2;
      }

      &.active {
        background: #0f6fe2;
        color: #fff;
        border-color: #0f6fe2;
      }
    }
  }
}

.region-categories {
  padding: 20px;
  background: #fff;

  .region-category {
    display: flex;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .category-name {
      min-width: 60px;
      font-size: 14px;
      color: #666;
      font-weight: 500;
      padding: 8px 0;
      margin-right: 20px;
    }

    .region-items {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .region-item {
        padding: 6px 12px;
        background: #f8f9fa;
        border: 1px solid #e9ecef;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        font-size: 14px;
        color: #333;
        white-space: nowrap;

        &:hover {
          background: #e9ecef;
          border-color: #0f6fe2;
        }

        &.active {
          background: #0f6fe2;
          color: #fff;
          border-color: #0f6fe2;
        }
      }
    }
  }
}

// 用户信息区域
.user-info-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;

  .user-avatar-info {
    display: flex;
    align-items: center;
    gap: 15px;

    .dropdown-avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      object-fit: cover;
    }

    .user-details {
      .username {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
      }

      .user-status {
        .status-badge {
          display: inline-flex;
          align-items: center;
          color: #0f6fe2;
          padding: 4px 0;
          border-radius: 20px;
          font-size: 15px;
          font-weight: 500;
          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }

        .status-badge.member-status {
          color: #FF6F00;
          background: linear-gradient(135deg, rgba(255, 224, 130, 0.3) 0%, rgba(255, 204, 2, 0.3) 100%);
          padding: 4px 12px;
        }

        .status-badge.role-badge {
          color: #0f6fe2;
          font-weight: 600;
          padding: 4px 0;
        }

        .member-days-text {
          font-size: 13px;
          color: #E65100;
          margin-left: 4px;
        }
      }
    }
  }

  .logout-btn {
    background: #f5f5f5;
    color: #666;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: #e8e8e8;
      color: #333;
    }
  }
}
// 会员区域
.membership-section {
  width: 100%;
}
.vip-text {
  width: 100px;
  height: 50px;
  color: #fff;
  background: #601f00;
  border-radius: 100px;
  text-align: center;
  line-height: 50px;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}

// 未登录菜单区域
.guest-menu {
  padding: 10px 0;

  .guest-menu-item {
    padding: 12px 30px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #f8f9fa;
    }

    .guest-menu-text {
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
  }
}

// 功能选项区域
.profile-options {
  padding: 0 30px 15px;

  .option-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f8f9fa;
      padding: 15px 10px;
      margin: 0 -10px;
      border-radius: 8px;
    }

    .option-icon {
      width: 20px;
      height: 20px;
      margin-right: 15px;
      object-fit: contain;
    }

    .option-text {
      flex: 1;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }

    .arrow-icon {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
  }
}

// 响应式设计 — 15 寸及以下笔记本（1600px）
@media (max-width: 1600px) {
  .navbar {
    height: 64px;
    padding: 0 12px;

    .logo-container {
      margin-right: 16px;

      .app-logo {
        width: 120px;
      }
    }

    .location-selector .location-text {
      font-size: 16px;
      padding: 6px 10px;

      .el-icon-arrow-down {
        width: 14px;
      }
    }

    .nav-links {
      gap: 8px;

      .nav-link {
        height: 64px;
        line-height: 64px;
        font-size: 15px;
        padding: 0 10px;

        &.active {
          height: 64px;
          line-height: 64px;
        }
      }
    }

    .right-menu {
      .auth-entry-buttons {
        gap: 8px;

        .auth-btn {
          padding: 8px 12px;
          font-size: 12px;
        }
      }

      .avatar-container .avatar-wrapper {
        padding: 6px 12px;
        gap: 8px;

        .username {
          font-size: 13px;
        }
      }
    }
  }

  ::v-deep .location-dropdown {
    min-width: 480px !important;
    max-width: 560px !important;
  }
}

// 13/14 寸常见 1366px
@media (max-width: 1366px) {
  .navbar {
    height: 56px;
    padding: 0 8px;

    .logo-container {
      margin-right: 10px;

      .app-logo {
        width: 100px;
      }
    }

    .location-selector .location-text {
      font-size: 14px;
      padding: 4px 6px;
    }

    .nav-links {
      gap: 4px;

      .nav-link {
        height: 56px;
        line-height: 56px;
        font-size: 14px;
        padding: 0 8px;

        &.active {
          height: 56px;
          line-height: 56px;
        }
      }
    }

    .right-menu {
      .auth-entry-buttons .auth-btn {
        padding: 6px 10px;
        font-size: 11px;
      }
    }
  }

  ::v-deep .location-dropdown {
    min-width: 420px !important;
    max-width: 520px !important;
  }
}

// 响应式设计（1200px 以下在 1366 笔记本规则基础上微调，不放大下拉框）
@media (max-width: 1200px) {
  .navbar {
    .nav-links {
      gap: 12px;

      .nav-link {
        padding: 0 8px;
        font-size: 13px;
      }
    }
  }

  ::v-deep .location-dropdown {
    min-width: min(420px, 92vw) !important;
    max-width: 92vw !important;
  }

  .popular-regions-header {
    padding: 12px 15px;
    gap: 15px;

    .popular-regions {
      gap: 10px;

      .popular-region-item {
        padding: 5px 10px;
        font-size: 13px;
      }
    }
  }

  .region-categories {
    padding: 15px;

    .region-category {
      margin-bottom: 12px;

      .category-name {
        min-width: 50px;
        font-size: 13px;
        margin-right: 15px;
      }

      .region-items {
        gap: 6px;

        .region-item {
          padding: 5px 10px;
          font-size: 13px;
        }
      }
    }
  }

    .right-menu {
      ::v-deep .user-dropdown {
        min-width: 280px;

        .user-info-section {
          padding: 15px;

          .user-avatar-info {
            .dropdown-avatar {
              width: 45px;
              height: 45px;
            }

            .user-details {
              .username {
                font-size: 15px;
              }
            }
          }
        }

        .membership-section {
          margin: 12px;
          padding: 15px;

          .vip-icon {
            width: 35px;
            height: 35px;
          }

          .membership-text {
            font-size: 13px;
          }
        }

        .profile-options {
          padding: 0 12px 12px;

          .option-item {
            padding: 12px 0;

            .option-icon {
              width: 18px;
              height: 18px;
            }

            .option-text {
              font-size: 13px;
            }
          }
        }
      }
    }
  }

@media (max-width: 768px) {
  .navbar {
    padding: 0 15px;

    .logo-container {
      margin-right: 20px;

      .app-logo {
        font-size: 20px;
      }
    }

    .location-selector {
      margin-right: 20px;
    }

    .nav-links {
      gap: 15px;

      .nav-link {
        padding: 6px 10px;
        font-size: 12px;
      }
    }
  }

  ::v-deep .location-dropdown {
    min-width: 300px !important;
    max-width: 90vw !important;
  }

  .popular-regions-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 15px;

    .header-label {
      min-width: auto;
    }

    .popular-regions {
      width: 100%;
      gap: 8px;

      .popular-region-item {
        padding: 4px 8px;
        font-size: 12px;
      }
    }
  }

  .region-categories {
    padding: 10px 15px;

    .region-category {
      flex-direction: column;
      margin-bottom: 10px;

      .category-name {
        min-width: auto;
        margin-right: 0;
        margin-bottom: 8px;
        font-size: 12px;
      }

      .region-items {
        gap: 5px;

        .region-item {
          padding: 4px 8px;
          font-size: 12px;
        }
      }
    }
  }

    .right-menu {
      ::v-deep .user-dropdown {
        min-width: 260px;

        .user-info-section {
          padding: 12px;

          .user-avatar-info {
            .dropdown-avatar {
              width: 40px;
              height: 40px;
            }

            .user-details {
              .username {
                font-size: 14px;
              }
            }
          }
        }

        .membership-section {
          margin: 10px;
          padding: 12px;

          .vip-icon {
            width: 30px;
            height: 30px;
          }

          .membership-text {
            font-size: 12px;
          }

          .activate-btn {
            padding: 6px 12px;
            font-size: 11px;
          }
        }

        .profile-options {
          padding: 0 10px 10px;

          .option-item {
            padding: 10px 0;

            .option-icon {
              width: 16px;
              height: 16px;
            }

            .option-text {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
</style>
